<app-page-breadcrumb pageTitle="Usuarios"></app-page-breadcrumb>

<div class="space-y-4">
  @if (!canUseModule) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <p class="text-error-600 dark:text-error-400 font-semibold">Sin permisos</p>
          <p class="text-error-600/90 dark:text-error-400/90 text-sm">
            Este módulo requiere rol <b>Manager</b> o superior.
          </p>
        </div>
      </div>
    </div>
  }

  @if (canUseModule) {
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <div class="flex items-center gap-1.5"></div>

      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
            </path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>

        <button
          *appHasPermission="'users:create'"
          type="button"
          (click)="create()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Nuevo
        </button>
      </div>
    </div>

    @if (showFilters) {
      <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3">
          <div class="lg:col-span-2">
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Buscar por Gmail o nombre
            </label>
            <input
              type="text"
              [(ngModel)]="filtroTerm"
              (ngModelChange)="buscar()"
              placeholder="Ej: correo@... / Juan"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Estado
            </label>
            <select
              [(ngModel)]="filtroActivo"
              (ngModelChange)="buscar()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option [ngValue]="undefined">Todos</option>
              <option [ngValue]="true">Activos</option>
              <option [ngValue]="false">Inactivos</option>
            </select>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Rol
            </label>
            <select
              [(ngModel)]="filtroRoleId"
              (ngModelChange)="buscar()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option [ngValue]="undefined">Todos</option>
              @for (r of roles; track r.id) {
                <option [ngValue]="r.id">{{ r.name }}</option>
              }
            </select>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Ordenar por
            </label>
            <select
              [(ngModel)]="sortBy"
              (ngModelChange)="buscar()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option [ngValue]="'updated'">Más reciente</option>
              <option [ngValue]="'mail'">Gmail</option>
              <option [ngValue]="'name'">Nombre</option>
              <option [ngValue]="'role'">Rol</option>
            </select>
          </div>

          <div class="flex items-end gap-2">
            <button
              type="button"
              (click)="toggleSortDir()"
              class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 w-full">
              {{ sortDir === 'asc' ? 'Asc' : 'Desc' }}
            </button>

            <button
              type="button"
              (click)="limpiarFiltro()"
              class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 w-full">
              Limpiar
            </button>
          </div>
        </div>
      </div>
    }

    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando usuarios...</span>
      </div>
    }

    @if (error) {
      <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
        <div class="flex items-center gap-3">
          <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    @if (!loading && !error) {
      <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="max-w-full overflow-x-auto custom-scrollbar">
          <table class="min-w-full">
            <thead class="border-b border-gray-100 dark:border-white/[0.05]">
              <tr>
                <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Gmail</th>
                <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
                <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Rol</th>
                <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
                <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
              </tr>
            </thead>

            <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
              @if (users.length === 0) {
                <tr>
                  <td colspan="5" class="px-5 py-8 text-center">
                    <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                      <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                              d="M16 7a4 4 0 10-8 0 4 4 0 008 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                      </svg>
                      <span>No hay usuarios para mostrar</span>
                    </div>
                  </td>
                </tr>
              }

              @for (u of users; track u.id) {
                <tr>
                  <td class="px-4 py-3 text-start">
                    <span class="block font-medium text-gray-800 dark:text-white/90 break-all">
                      {{ u.mail }}
                    </span>
                  </td>

                  <td class="px-4 py-3 text-start">
                    <span class="block font-medium text-gray-800 dark:text-white/90">
                      {{ (u.fullname || '-') }} {{ (u.lastname || '') }}
                    </span>
                  </td>

                  <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    {{ roleLabel(u.idRol, u.roleName) }}
                  </td>

                  <td class="px-4 py-3 text-start">
                    <app-badge [color]="getEstadoColor(u)">{{ getEstadoLabel(u) }}</app-badge>
                  </td>

                  <td class="px-4 py-3 text-center">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        type="button"
                        (click)="verUser(u)"
                        class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                        title="Ver">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                      </button>

                      <button
                        *appHasPermission="'users:edit'"
                        type="button"
                        (click)="edit(u)"
                        [disabled]="!isSuperAdmin"
                        class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Editar">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                          </path>
                        </svg>
                      </button>

                      @if ((u.isActive ?? true) !== false) {
                        <button
                          *appHasPermission="'users:edit'"
                          type="button"
                          (click)="deactivate(u)"
                          [disabled]="!isSuperAdmin"
                          class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          title="Desactivar">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M18 9v3m0 0v3m0-3h3m-3 0h-3M8 7a4 4 0 118 0v1M6 21a2 2 0 01-2-2v-5a4 4 0 014-4h4">
                            </path>
                          </svg>
                        </button>
                      } @else {
                        <button
                          *appHasPermission="'users:edit'"
                          type="button"
                          (click)="activate(u)"
                          [disabled]="!isSuperAdmin"
                          class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          title="Activar">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M16 3.13a4 4 0 010 7.75M20 8v6m3-3h-6">
                            </path>
                          </svg>
                        </button>
                      }

                      <button
                        *appHasPermission="'users:edit'"
                        type="button"
                        (click)="openResetPassword(u, $event)"
                        [disabled]="!canResetPassword(u)"
                        class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Restablecer contraseña">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5 9 6.343 9 8s1.343 3 3 3z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 20a8 8 0 0116 0"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M16 11v6m3-3h-6"/>
                        </svg>
                      </button>

                      @if (isSuperAdmin && currentUserId !== u.id && (u.isActive ?? true) === false) {
                        <button
                          *appHasPermission="'users:delete'"
                          type="button"
                          (click)="deleteUserData(u)"
                          class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                          title="Eliminar datos del usuario">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>
                      } @else if (isSuperAdmin && currentUserId !== u.id) {
                        <button
                          type="button"
                          (click)="mostrarAvisoDebeEstarInactivo()"
                          class="rounded-lg p-2 opacity-40 cursor-not-allowed"
                          title="El usuario debe estar Inactivo para poder eliminarlo">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (globalTotalPages >= 1) {
        <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
              <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                       bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                       focus:ring-2 focus:ring-brand-500 focus:border-transparent">
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                       bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                       hover:bg-gray-50 dark:hover:bg-gray-700
                       disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                Anterior
              </button>
              <div class="flex items-center gap-1.5">
                <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
                <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
                  class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                         bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                         focus:ring-2 focus:ring-brand-500 focus:border-transparent">
                  @for (p of pagesArray; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
                <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
              </div>
              <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                       bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                       hover:bg-gray-50 dark:hover:bg-gray-700
                       disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                Siguiente
              </button>
            </div>
          </div>
        </div>
        }
      </div>
    }

    <!--
      Detalle estándar del sistema: componente propio con encabezado de avatar y pestañas
      Información + Línea de tiempo, igual que contactos, empresas, workflows o segmentos.
      Antes vivía embebido aquí como un bloque plano sin historial.
    -->
    <app-user-detail-modal
      [isOpen]="isDetailOpen"
      [user]="selectedUser"
      [roles]="roles"
      [businessName]="selectedUserBusinessName"
      [canEdit]="isSuperAdmin"
      (close)="cerrarDetalle()"
      (edit)="edit($event)" />

    <app-modal [isOpen]="isResetOpen" (close)="closeResetPassword()" className="max-w-lg mx-4 sm:mx-6">
      @if (resetTargetUser) {
        <div class="p-6 sm:p-7">
          <div class="flex items-start justify-between gap-4 mb-6">
            <div class="min-w-0">
              <h2 class="text-xl font-bold text-gray-900 dark:text-white truncate">
                Restablecer contraseña
              </h2>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1 break-all">
                {{ resetTargetUser.mail }}
              </p>
            </div>

            <button
              type="button"
              (click)="closeResetPassword()"
              class="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
              aria-label="Cerrar">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <div class="space-y-4">
            <div class="flex items-start gap-3 p-4 rounded-lg border border-brand-100 bg-brand-50/60
                        dark:border-brand-500/20 dark:bg-brand-500/10">
              <svg class="w-5 h-5 flex-shrink-0 text-brand-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"/>
              </svg>
              <p class="text-sm text-gray-700 dark:text-gray-300">
                Se enviará un correo con un <b>enlace seguro de restablecimiento</b> a este usuario.
                El enlace expira en 30 minutos y permite que el usuario defina su propia contraseña
                sin que tú tengas que conocerla.
              </p>
            </div>

            @if (resetError) {
              <div class="p-3 rounded-lg border border-error-200 bg-error-50 text-error-700
                          dark:border-error-900/40 dark:bg-error-900/20 dark:text-error-300">
                {{ resetError }}
              </div>
            }

            @if (resetSuccess) {
              <div class="p-3 rounded-lg border border-green-200 bg-green-50 text-green-700
                          dark:border-green-900/40 dark:bg-green-900/20 dark:text-green-300">
                {{ resetSuccess }}
              </div>
            }
          </div>

          <div class="flex items-center justify-end gap-3 pt-6 border-t border-gray-200 dark:border-gray-700 mt-6">
            <button
              type="button"
              (click)="closeResetPassword()"
              class="px-4 py-2 text-sm rounded-lg font-medium transition-colors
                     bg-gray-100 dark:bg-gray-800
                     text-gray-700 dark:text-gray-300
                     hover:bg-gray-200 dark:hover:bg-gray-700">
              Cancelar
            </button>

            <button
              type="button"
              (click)="sendResetLink()"
              [disabled]="resettingPassword || !!resetSuccess"
              class="px-4 py-2 text-sm rounded-lg font-medium transition-colors
                     bg-brand-500 text-white hover:bg-brand-600
                     disabled:opacity-50 disabled:cursor-not-allowed">
              {{ resettingPassword ? 'Enviando...' : 'Enviar enlace' }}
            </button>
          </div>
        </div>
      }
    </app-modal>

    <app-modal [isOpen]="isDeleteOpen" (close)="closeDeleteUserData()" className="max-w-lg mx-4 sm:mx-6">
      @if (deleteTargetUser) {
        <div class="p-6 sm:p-7">
          <div class="flex items-start justify-between gap-4 mb-6">
            <div class="min-w-0">
              <h2 class="text-xl font-bold text-gray-900 dark:text-white truncate">
                Eliminar datos del usuario
              </h2>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1 break-all">
                {{ deleteTargetUser.mail }}
              </p>
            </div>

            <button
              type="button"
              (click)="closeDeleteUserData()"
              class="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
              aria-label="Cerrar">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <div class="space-y-4">
            <div class="p-3 rounded-lg border border-error-200 bg-error-50 text-error-700 text-sm
                        dark:border-error-900/40 dark:bg-error-900/20 dark:text-error-300">
              Esta acción anonimizará los datos del usuario y es irreversible. Ingresa tu contraseña
              de administrador para confirmar.
            </div>

            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                Tu contraseña
              </label>
              <input
                type="password"
                [(ngModel)]="deletePassword"
                (keyup.enter)="confirmDeleteUserData()"
                placeholder="••••••••"
                class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            </div>

            @if (deleteError) {
              <div class="p-3 rounded-lg border border-error-200 bg-error-50 text-error-700
                          dark:border-error-900/40 dark:bg-error-900/20 dark:text-error-300">
                {{ deleteError }}
              </div>
            }
          </div>

          <div class="flex items-center justify-end gap-3 pt-6 border-t border-gray-200 dark:border-gray-700 mt-6">
            <button
              type="button"
              (click)="closeDeleteUserData()"
              class="px-4 py-2 text-sm rounded-lg font-medium transition-colors
                     bg-gray-100 dark:bg-gray-800
                     text-gray-700 dark:text-gray-300
                     hover:bg-gray-200 dark:hover:bg-gray-700">
              Cancelar
            </button>

            <button
              type="button"
              (click)="confirmDeleteUserData()"
              [disabled]="deletingUserData || !deletePassword"
              class="px-4 py-2 text-sm rounded-lg font-medium transition-colors
                     bg-error-500 text-white hover:bg-error-600
                     disabled:opacity-50 disabled:cursor-not-allowed">
              {{ deletingUserData ? 'Eliminando...' : 'Eliminar' }}
            </button>
          </div>
        </div>
      }
    </app-modal>
  }
</div>
